import React from "react";
export const MessageCalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx="16" cy="16" r="15.5" fill="#245CEA" stroke="#245CEA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.8805 9.94301C24.3346 10.8343 24.3346 12.0011 24.3346 14.3346V15.3215C24.3346 16.7291 24.3346 17.4329 24.1663 18.007C23.767 19.3688 22.7021 20.4337 21.3403 20.833C20.7662 21.0013 20.0624 21.0013 18.6548 21.0013H18.1975L18.1432 21.0014C17.293 21.0068 16.4648 21.2722 15.7698 21.762L15.7256 21.7934L13.55 23.3474C12.8042 23.8802 11.8242 23.1108 12.1646 22.2598C12.4057 21.657 11.9617 21.0013 11.3125 21.0013H10.811C9.07516 21.0013 7.66797 19.5941 7.66797 17.8583V14.3346C7.66797 12.0011 7.66797 10.8343 8.12211 9.94301C8.52158 9.159 9.159 8.52158 9.94301 8.12211C10.8343 7.66797 12.0011 7.66797 14.3346 7.66797H17.668C20.0015 7.66797 21.1683 7.66797 22.0596 8.12211C22.8436 8.52158 23.481 9.159 23.8805 9.94301ZM12.668 12.043C12.3228 12.043 12.043 12.3228 12.043 12.668C12.043 13.0131 12.3228 13.293 12.668 13.293L16.0013 13.293C16.3465 13.293 16.6263 13.0131 16.6263 12.668C16.6263 12.3228 16.3465 12.043 16.0013 12.043L12.668 12.043ZM12.668 15.3763C12.3228 15.3763 12.043 15.6561 12.043 16.0013C12.043 16.3465 12.3228 16.6263 12.668 16.6263H19.3346C19.6798 16.6263 19.9596 16.3465 19.9596 16.0013C19.9596 15.6561 19.6798 15.3763 19.3346 15.3763H12.668Z"
        fill="white"
      />
    </svg>
  );
};
